<template>
  <div>
    <div v-if="!detail">
      <b-field :label="$t('produitSalon.marche.field')">
        <b-autocomplete
          :value="search"
          :data="marchesFilter"
          :loading="isFetchingMarche"
          :disabled="disabledVal"
          @select="setMarche"
          @input="getAsyncMarcheData"
          field="label"
          icon="magnify"
          type="is-primary"
          open-on-focus>
          <template slot="empty">
            <div v-if="!isFetchingMarche">
              {{$t('general.autocomplete.noRslt')}}
            </div>
            <div v-else>
              {{$t('general.autocomplete.search')}}
            </div>
          </template>
        </b-autocomplete>
      </b-field>
    </div>
    <div v-else>
      <p class="has-text-default is-italic">
        {{ $t('produitSalon.marche.field') + ' :' }}
      </p>
      <router-link-blank
        v-if="marche"
        :to="{ name: 'c.presse.marche', params: { id: marche.id } }"
        :message="genererLibelle(marche)"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll as getAllMarche, get as getMarche } from '@/api/achat/marche';
import messageErreur from '@/services/general/messageErreur';
import { transformer as serverTableDataTransformer } from '@/services/achat/marche/serverTableDataTransformer';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'CatalogueProduitGeneralPresseEditMarche',
  components: {
    routerLinkBlank,
  },
  props: {
    produit: {
      type: Object,
      required: false,
    },
    detail: {
      type: Boolean,
      required: false,
    },
    societeId: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      search: '',
      marche: null,
      marchesFilter: [],
      isFetchingMarche: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    disabledVal() {
      if (typeof this.disabled === 'boolean') return this.disabled;
      return !!this.produit.regroupementProduitId;
    },
  },
  methods: {
    getAsyncMarcheData: debounce(async function getData(text) {
      if (text === this.search) return;
      if (text === '') {
        this.search = '';
        this.produit.marcheId = null;
      }
      try {
        this.isFetchingMarche = true;
        const payload = {
          skipCount: 0,
          maxResultCount: RESULTS_PER_PAGE,
          query: {
            auto: text,
            societeId: this.societeId ?? this.societeActiveId,
          },
        };
        serverTableDataTransformer(payload);
        this.marchesFilter = (await getAllMarche(payload))
          .data.result.items
          .map(m => ({ ...m, label: this.genererLibelle(m) }));
        this.isFetchingMarche = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingMarche = false;
        throw e;
      }
    }, 500),
    setMarche(marche) {
      if (!marche) return;
      this.search = this.genererLibelle(marche);
      this.produit.marcheId = marche.id;
      this.marchesFilter = [marche];
    },
    genererLibelle(marche) {
      return `${marche.code} - ${marche.libelle}`;
    },
  },
  async mounted() {
    const marcheId = this.produit.marcheId || this.$route.params.marcheId;
    try {
      if (marcheId) {
        this.marche = (await getMarche(marcheId)).data.result;
        this.search = this.genererLibelle(this.marche);
        this.produit.marcheId = this.marche.id;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
